import { h, createContext } from "preact";
import { useReducer } from "preact/hooks";
import { APP_KEY, STORY_URL } from "./constants";
import { parseJWT } from "./helper";

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
// const apiKey = urlParams.get("api_key");
// const storyUrl = urlParams.get("story_url");
const sharedCommentId = urlParams.get("emotify_comment_id");

const jwtToken = urlParams.get("token");
const decodedToken = parseJWT(jwtToken);

const storyUrl = decodedToken?.storyUrl ?? STORY_URL;
const widgetSettings = decodedToken?.widgetSettings ?? null;

const apiKey = widgetSettings?.apiKey ?? APP_KEY;

// Widget Settings. Fetch from decoded token.
const color = widgetSettings?.color ?? "#4264fb";
const comment = widgetSettings?.comment ?? true;
const reaction = widgetSettings?.reaction ?? true;
const reply = widgetSettings?.reply ?? true;
const commentReaction = widgetSettings?.commentReaction ?? true;
const commentShare = widgetSettings?.commentReaction ?? true;
const allowGuestComments = widgetSettings?.allowGuestComments ?? true;
const preModerate = widgetSettings?.preModerate ?? true;
const followStory = widgetSettings?.followStory ?? true;

export const Context = createContext();

const initialState = {
  // API Key and Story URL
  apiKey,
  storyUrl,
  // Selected Comment
  selectedId: 0,
  isIdSelected: false,
  // UserInfoModal
  userInfo: null,
  userInfoVisible: false,
  loginVisible: false,
  // Comment ID from shareable comment URL
  sharedCommentId: sharedCommentId ?? null,
  // Widget Settings
  color,
  comment,
  reaction,
  reply,
  commentReaction,
  commentShare,
  allowGuestComments,
  preModerate,
  followStory,
};

function reducer(state, action) {
  switch (action.type) {
    case "CHANGE_ID":
      return {
        ...state,
        selectedId: action.payload.id,
        isIdSelected: action.payload.isSelected,
      };

    case "SET_USER_INFO":
      return {
        ...state,
        userInfo: action.payload.userInfo,
        userInfoVisible: action.payload.visible,
      };

    case "SET_LOGIN_VISIBLE":
      return {
        ...state,
        loginVisible: action.payload.visible,
      };

    case "RESET_SHARED_COMMENT_ID":
      return {
        ...state,
        sharedCommentId: null,
      };

    default:
      return state;
  }
}

export function Provider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <Context.Provider value={{ state, dispatch }}>{children}</Context.Provider>
  );
}

export function changeId(id, isSelected) {
  return {
    type: "CHANGE_ID",
    payload: {
      id,
      isSelected,
    },
  };
}

export function setUserInfoAction(userInfo, visible) {
  return {
    type: "SET_USER_INFO",
    payload: {
      userInfo,
      visible,
    },
  };
}

export function setLoginModalVisible(visible) {
  return {
    type: "SET_LOGIN_VISIBLE",
    payload: {
      visible,
    },
  };
}

export function resetSharedCommentId() {
  return {
    type: "RESET_SHARED_COMMENT_ID",
  };
}
